import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, Zap } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SERVICE_DETAILS } from "@/pages/Services";

const Services = () => (
  <section id="services" className="bg-white py-16 md:py-28" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="mb-3 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-petrol md:text-sm">
          <Zap className="h-3.5 w-3.5 animate-spark-flicker text-copper" strokeWidth={2} fill="currentColor" />
          01 — Services
        </p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tight text-petrol md:text-6xl">
          What we do
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 md:mt-16 md:gap-5 lg:grid-cols-3">
        {SERVICE_DETAILS.map((s, i) => (
          <motion.div
            key={s.slug}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.06 * i, ease: [0.16, 1, 0.3, 1] }}
          >
            <Link
              to={`/services#${s.slug}`}
              className="group flex h-full flex-col border-2 border-ink bg-white p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-copper hover:shadow-[6px_6px_0_#c8925a] md:p-7"
              data-testid={`service-card-${i}`}
            >
              <span className="mb-3 h-1.5 w-10 bg-copper transition-all duration-300 group-hover:w-16 md:mb-5" aria-hidden="true" />
              <h3 className="font-display text-sm font-bold uppercase tracking-tight text-ink md:text-xl">
                {s.title}
              </h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-ink/60 md:mt-3 md:text-base">{s.short}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.2em] text-petrol transition-colors group-hover:text-ink md:mt-5 md:text-xs">
                Learn more
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
      <Reveal className="mt-12 flex flex-wrap items-center justify-center gap-4 md:mt-14">
        <Link
          to="/quote"
          data-testid="services-quote-button"
          className="group inline-flex items-center gap-2 bg-petrol px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-copper hover:text-ink"
        >
          Free Quote
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
        </Link>
        <Link
          to="/services"
          data-testid="services-see-all-button"
          className="group inline-flex items-center gap-2 border-2 border-ink px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:border-copper hover:bg-copper"
        >
          See Services
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Services;
